import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/**
 * @param {{
 *   params: { tagId: string },
 *   body: {
 *     entityType: 'CrmCustomer',
 *     ruleType: 'Reminder',
 *     nextActionSeconds: number,
 *     plainText: string,
 *     requiredFields: string[],
 *     isActive?: boolean
 *   }
 * }} option
 */
export const Create = async (option) => {
  const response = await $api.post(
    Endpoints.TagRule.Create({ params: option.params }),
    option.body
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { tagId: string }, query?: object }} option
 */
export const GetByTagId = async (option) => {
  const response = await $api.get(Endpoints.TagRule.GetByTagId(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{
 *   params: { id: string },
 *   body: {
 *     nextActionSeconds?: number,
 *     plainText?: string,
 *     requiredFields?: string[],
 *     isActive?: boolean
 *   }
 * }} option
 */
export const Update = async (option) => {
  const response = await $api.put(
    Endpoints.TagRule.Update({ params: option.params }),
    option.body
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { id: string } }} option
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.TagRule.Delete(option));
  return ResponseChecker(defaultMessages, response);
};

export default {
  Create,
  GetByTagId,
  Update,
  Delete,
};